import { useEffect } from "react";

export default function Seo({ title, description }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            const m = document.querySelector('meta[name="description"]');
            if (m) m.setAttribute("content", description);
        }
    }, [title, description]);
    return null;
}
